import React, { useMemo } from "react";

import { Body2 } from "../Typography";
import { makeStyles } from "@material-ui/core";

export type Props = {
  header: string;
  limit?: number;
  codes: string[];
  highlight?: string;
};

export const viewCodesButtonStyle = {
  fontFamily: "Figtree, sans-serif",
  fontWeight: 700,
  fontSize: 13,
  lineHeight: "120%",
  verticalAlign: "middle",
  color: "#027691",
  cursor: "pointer",
  background: "none",
  border: "none",
  padding: 0,
  "&:hover": {
    opacity: 0.7,
  },
} as const;

function renderCode(code: string, index: number, highlight?: string) {
  const isBold = Boolean(highlight && code.toLowerCase().startsWith(highlight.toLowerCase()));
  return isBold ? <b key={index}>{code}</b> : <React.Fragment key={index}>{code}</React.Fragment>;
}

function buildCodeList(displayCodes: string[], overflow: number, highlight?: string): React.ReactNode {
  if (displayCodes.length === 0) {
    return null;
  }

  const nodes: React.ReactNode[] = [];

  displayCodes.forEach((code, i) => {
    const isLast = i === displayCodes.length - 1;

    if (i > 0) {
      if (!isLast || overflow > 0) {
        nodes.push(", ");
      } else {
        nodes.push(" and ");
      }
    }

    nodes.push(renderCode(code, i, highlight));
  });

  if (overflow > 0) {
    nodes.push(` and ${overflow} more`);
  }
  if (displayCodes.length > 1) {
    nodes.push(".");
  }

  return nodes;
}

export function GroupCodesAutocompleteOption({ header, limit = 10, codes, highlight }: Props) {
  const overflow = Math.max(0, codes.length - limit);
  const displayCodes = codes.slice(0, limit);
  const codeList = buildCodeList(displayCodes, overflow, highlight);
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Body2 className={classes.header}>{header}</Body2>
      <Body2 className={classes.includes}>
        <span>Includes {codeList}</span>
      </Body2>
    </div>
  );
}

const useStyles = makeStyles({
  container: { display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" },
  header: {
    fontWeight: 400,
    fontFamily: "Gilroy-SemiBold",
    fontSize: "15px",
    color: "#212936",
    lineHeight: "normal",
  },
  includes: {
    fontWeight: 400,
    fontFamily: "Figtree",
    fontSize: "13px",
    lineHeight: "120%",
    color: "#657286",
    display: "flex",
    flexDirection: "row",
    gap: "4px",
    alignItems: "center",
  },
});
